
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M7.007 12a.75.75 0 01.75-.75h3.493V7.757a.75.75 0 011.5 0v3.493h3.493a.75.75 0 110 1.5H12.75v3.493a.75.75 0 01-1.5 0V12.75H7.757a.75.75 0 01-.75-.75"}}),_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M7.317 3.769a42.5 42.5 0 019.366 0c1.827.204 3.302 1.643 3.516 3.48.37 3.157.37 6.346 0 9.503-.215 1.837-1.69 3.275-3.516 3.48a42.5 42.5 0 01-9.366 0c-1.827-.205-3.302-1.643-3.516-3.48a41 41 0 010-9.503c.214-1.837 1.69-3.276 3.516-3.48m9.2 1.49a41 41 0 00-9.034 0A2.486 2.486 0 005.29 7.424a39.4 39.4 0 000 9.154 2.486 2.486 0 002.193 2.164c2.977.332 6.057.332 9.034 0a2.486 2.486 0 002.192-2.164 39.4 39.4 0 000-9.154 2.486 2.486 0 00-2.192-2.163","clip-rule":"evenodd"}})])
          )
        }
      }
    